import { useEffect, useState } from "react";
import { setShowLoading } from "../store/sysSlice";
import { useDispatch } from "react-redux";
import { Slide, Stack, Typography } from "@mui/material";
import LOGO from '../assets/logo.png'
import Lottie from "lottie-react";
import ERROR_404 from '../assets/error404.json'
import Footer from "../components/Footer";

const Error404 = () => {
  const dispatch = useDispatch()
  const [show, setShow] = useState(false);

  useEffect(() => {
    dispatch(setShowLoading(false));
    const timer = setTimeout(() => {
      setShow(true);
    }, 900);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Stack
      height='100%'
      alignItems='center'
      justifyContent='space-between'
    >
      <Stack
        width='100%'
        height={80}
        alignItems='end'
        justifyContent='center'
        bgcolor='primary.main'
        boxShadow={2}
      >
        <Slide in={show} direction="right">
          <Stack px={1} direction='row' alignItems='end' >
            <Stack alignItems='end'>
              <Typography color='secondary.main' variant="h5">
                MyBee
              </Typography>
              <Typography color='secondary.main' fontWeight='bold' fontSize={12}>
                Make it smart & simple
              </Typography>
            </Stack>
            <img src={LOGO} style={{ fill: '000' }} width={50} />
          </Stack>
        </Slide>
      </Stack>

      <Stack padding={3} alignItems='center' spacing={2}>
        <Stack width={350}><Lottie animationData={ERROR_404} /></Stack>
      </Stack>

      <Stack width='100%'>
        <Footer />
      </Stack>
    </Stack>
  );
};
export default Error404;
